import { render, staticRenderFns } from "./single-account-cbr-dialog.vue?vue&type=template&id=6a64d6f5"
import script from "./single-account-cbr-dialog.vue?vue&type=script&lang=js"
export * from "./single-account-cbr-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports